import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { DataType, Legislation } from "../models/lookups";
import { CongressionalDistrict, CongressionalDistrictDto } from "../models/congressional-district";
import { ScorecardView } from "../models/views";

@Injectable({ providedIn: "root" })

export class VoteScorecardApiService {
    constructor(private http: HttpClient) {}

    path = `${environment.voteScorecardApiUrl}`;

    getStates = () => this.http.get<DataType[]>(`${this.path}/lookups/states`);

    getLegislation = () => this.http.get<Legislation[]>(`${this.path}/lookups/legislations`);

    getVoteTypes = () => this.http.get<DataType[]>(`${this.path}/lookups/vote`);

    getParties = () => this.http.get<DataType[]>(`${this.path}/lookups/party`);

    getCongressmenDatatype = () => this.http.get<DataType[]>(`${this.path}/congressmen/data-types`);

    getCongressionalDistricts(address?: string, localUnionNumber?: string) {
        const params: Record<string, string> = {};
        if (address) params['address'] = address;
        if (localUnionNumber) params['localUnionNumber'] = localUnionNumber;

        return this.http.get<CongressionalDistrictDto[]>(`${this.path}/congressionaldistricts`, { params });
    }

    getScorecard = (congressmanId?: number, stateId?: number, districtNumber?: number, localUnion?: number) => {
    const params: Record<string, string> = {};

    if (congressmanId)
        params["congressmanId"] = congressmanId.toString();
    if(localUnion)
        params["localUnion"] = localUnion.toString();
    if (stateId !== undefined)
        params["stateId"] = stateId.toString();
    if (districtNumber !== undefined && !Number.isNaN(districtNumber))
        params["district"] = districtNumber.toString();
    return this.http.get<ScorecardView[]>(`${this.path}/congressmen/scorecards`, { params })
};


}